import React, { useEffect } from "react";
import { createStyles, IconButton, makeStyles, Zoom } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";

type ToastSeverity = "success" | "error" | "warning" | "info";

type ToastProps = {
  open: boolean;
  message: string;
  severity?: ToastSeverity;
  duration?: number;
  onClose: () => void;
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: "fixed",
      top: 24,
      right: 40,
      zIndex: 99999,
      width: "auto",
      paddingRight: 8,
      pointerEvents: "none",
    },
    alert: {
      maxWidth: 420,
      width: "100%",
      borderRadius: 15,
      pointerEvents: "auto",
    },
  })
);

const Toast: React.FC<ToastProps> = ({
  open,
  message,
  severity = "success",
  duration = 4000,
  onClose,
}) => {
  const classes = useStyles();

  useEffect(() => {
    if (!open) {
      return;
    }

    const timer = window.setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      window.clearTimeout(timer);
    };
  }, [open, duration, onClose]);

  if (!open) {
    return null;
  }

  return (
    <Zoom in={open} timeout={300}>
      <div className={classes.root}>
        <Alert
          className={classes.alert}
          variant="filled"
          severity={severity}
          action={
            <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </div>
    </Zoom>
  );
};

export default Toast;
